import { supabase } from './supabaseClient';

const WEBHOOK_URL = process.env.REACT_APP_WEBHOOK_URL || '';

/**
 * Sends an email via webhook API (requires admin/provider auth).
 * Fire-and-forget: returns true/false, never throws.
 */
export async function triggerEmail(params: {
  templateKey: string;
  recipientEmail: string;
  recipientName?: string;
  language: 'pt' | 'en';
  variables: Record<string, string>;
  patientId?: string;
  appointmentId?: string;
}): Promise<boolean> {
  if (!WEBHOOK_URL) return false;

  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) return false;

    const res = await fetch(`${WEBHOOK_URL}/api/email/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    });
    return res.ok;
  } catch {
    return false;
  }
}

/**
 * Sends a welcome email (public endpoint, no auth required).
 * Only sends the welcome_patient template.
 */
export async function triggerWelcomeEmail(params: {
  email: string;
  firstName: string;
  lastName?: string;
  language: 'pt' | 'en';
}): Promise<boolean> {
  if (!WEBHOOK_URL) return false;

  try {
    const res = await fetch(`${WEBHOOK_URL}/email/welcome`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });
    return res.ok;
  } catch {
    return false;
  }
}
